import { navLinks, siteInfo } from '@/mocks/homeMangaData';

export default function Footer() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-foreground-950 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg text-sm font-bold">
                漫
              </span>
              <span className="font-heading text-lg font-bold">{siteInfo.name}</span>
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed mb-4">
              爱漫画网专注韩漫推荐、日漫大全与国漫排行榜，每日实时更新热门漫画排行与最新漫画连载，为漫画爱好者提供免费在线漫画阅读服务。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold mb-4 text-background-50">快速导航</h4>
            <div className="flex flex-col gap-2">
              {navLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
                  className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold mb-4 text-background-50">热门分类</h4>
            <div className="flex flex-col gap-2">
              <span className="text-sm text-foreground-300">韩漫推荐</span>
              <span className="text-sm text-foreground-300">日漫大全</span>
              <span className="text-sm text-foreground-300">国漫排行榜</span>
              <span className="text-sm text-foreground-300">热门漫画排行</span>
              <span className="text-sm text-foreground-300">最新漫画连载</span>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold mb-4 text-background-50">合作伙伴</h4>
            <p className="text-sm text-foreground-400">更多合作伙伴即将上线</p>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有
          </p>
          <p className="text-xs text-foreground-500">
            韩漫推荐 · 日漫大全 · 国漫排行榜 · 免费漫画在线阅读
          </p>
        </div>
      </div>
    </footer>
  );
}